/* @flow */

import clsx from 'clsx';
import * as React from 'react';

import { Theme, type ThemeType } from '../../helpers/ui/theme';
import './infiniteCircleLoaderArc.css';

type InfiniteCircleLoaderArcPropType = {
  +className?: string,
  +theme?: ThemeType,
};

const InfiniteCircleLoaderArc = ({ className, theme = Theme.Dark }: InfiniteCircleLoaderArcPropType): React.Node => <div aria-hidden className={clsx('infiniteCircleLoaderArc', className, theme)} />;

export default InfiniteCircleLoaderArc;
